import { StyleSheet } from 'react-native';
import { BLUE_COLOR, GREY_COLOR, WHITE_COLOR } from '../../styles/common';

const styles = StyleSheet.create({
    external_wrapper: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: WHITE_COLOR,
        boxShadow: '0px 14px 10px -10px rgb(0 0 0 / 10%)',
        height: 72,
        paddingLeft: 117,
        paddingRight: 60,
    },
    externalWrapperTablet: {
        paddingLeft: 38,
        paddingRight: 44,
        height: 67,
    },
    externalWrapperMobile: {
        paddingLeft: 38,
        paddingRight: 44,
        height: 62,
    },
    logoDesktop: {
        width: 180,
    },
    logoTablet: {
        width: 170,
    },
    logoPhone: {
        width: 150,
    },
    logout_button_wrapper: {
        flexDirection: 'row',
    },
    logout_button_wrapper_phone: {
        marginLeft: -25,
        flexDirection: 'row',
    },
    logout_button: {
        color: BLUE_COLOR,
        fontSize: 16,
    },
    username_text: {
        color: GREY_COLOR,
        fontSize: 16,
    },
    username_wrapper: {
        marginRight: 40,
    },
});

export default styles;
